import React, { useEffect, useRef } from 'react'

import { useSelector } from 'react-redux'
import { selectHash, selectBreadcrumbs } from '@selectors'

import { NavLink } from 'react-router-dom'

import Icon from '@components/icon/icon.component'
import Tag from '@components/tag/tag.component'

import useStyles from './breadcrumb.style'
import Slider from 'react-slick'

const BreadCrumbItem = ({ breadcrumb, icon }) => {
  const hash = useSelector(selectHash)
  const classes = useStyles()

  return (
    <NavLink
      className={classes.link}
      to={`/${hash.substring(0, 10)}${breadcrumb.to}`}
    >
      <Tag
        backgroundColor='rgba(58, 197, 227, 0.2)'
        color='#1EAEFF'
        isUpperCased={false}
        size='normal'
        text={breadcrumb.linkText}
      />
    </NavLink>
  )
}

const Breadcrumb = () => {
  const breadcrumbs = useSelector(selectBreadcrumbs)
  const sliderRef = useRef(null)

  useEffect(() => {
    if (breadcrumbs && sliderRef.current) {
      sliderRef.current.slickGoTo(breadcrumbs.length - 1)
    }
  }, [breadcrumbs, sliderRef])

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    adaptiveHeight: true,
    variableWidth: true,
    nextArrow: <Icon type='arrow-left' />,
    prevArrow: <Icon type='arrow-left' />
  }

  return (
    <Slider
      ref={sliderRef}
      {...settings}
    >
      {breadcrumbs.map((breadcrumb, i) => (
        <div key={breadcrumb.key}>
          <BreadCrumbItem breadcrumb={breadcrumb} />
        </div>
      ))}
    </Slider>
  )
}

export default Breadcrumb

